<template>
    <div>
        <div
            v-for="(item, index) in list"
            :key="index"
            class="chain"
            :class="{
                completed: item.completed,
                clickable: isClickable
            }"
        >
            <div
                class="circle"
                @click="activeThis(item, isClickable)"
            >
                <div class="status">
                    <em class="fal fa-check icon" />
                </div>
            </div>

            <div
                :class="{ clickable: isClickable }"
                @click="activeThis(item, isClickable)"
            >
                <h3
                    class="title"
                    :class="{ completed: item.completed }"
                >
                    {{ item.name }}
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "ui-chain-menu-3",

		props: {
			/**
			 * Array contendo as opções e configurações do menu
			 */
			value: {
				type: Array,
				default: () => [],
			},
			/**
			 * Define se as opções de menu são clicáveis
			 */
			clickable: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				list: [],
			}
		},

		computed: {
			/**
			 * Computed property que verifica se as opções do menu são clicáveis
			 */
			isClickable() {
				return this.clickable
			}
		},

		watch: {
			value: {
				deep: true,
				handler(newValue) {
					this.list = newValue
				},
			},
			list: {
				deep: true,
				handler(newValue) {
					this.$emit("input", newValue)
				},
			},
		},

		mounted() {
			this.list = this.value
		},

		methods: {
			/**
			 * Ativa uma das opções do menu
			 */
			activeThis(itemToActivate, bool) {
				if (!bool) return

				if (this.clickable) {
					this.list.forEach((item) => {
						item.active = item.slug === itemToActivate.slug
					})
				}
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
